import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ErrorDivStyled = styled.div`
    display: ${props => props.show ? 'inline' : 'none'};
    text-transform: capitalize;
    color: #CD2028;
    font-size: 12px;
    font-weight: 400;
`;

class ReCaptcha extends React.Component {

    render() {
        const error = this.props.error;

        return (
            <div>
                <ErrorDivStyled show={error}>
                    required
                </ErrorDivStyled>
                <ReCAPTCHA
                    ref='recaptcha'
                    sitekey='6Ld-4ykUAAAAAAmmDMNhohhaD1J3S2SQeOf6SNdm'
                    onChange={this.props.onChange} />
            </div>
        );
    }
}

ReCaptcha.propTypes = {
    error: PropTypes.bool,
    onChange: PropTypes.func
};

ReCaptcha.defaultProps = {
    error: false,
    onChange: () => {}
};

export default ReCaptcha;



// WEBPACK FOOTER //
// ./src/components/ReCaptcha/index.js